import React from "react";
import './css/searchBox.css';

const SearchBox = ({ value, onChange }) => {
  return (
      <input
        type="text"
        name="query"
        className="form-control my-3 searchbox"
        placeholder="Search any Product..."
        value={value}
        onChange={e => onChange(e.currentTarget.value)}
      />
  );
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/searchBox.jsx